module.exports = __webpack_public_path__ + "static/media/ticket-support_og.11022f20.png";